import type { FormatterCallbackFunction, LegendOptions, Point, Series } from 'highcharts';

const legendFormatter: FormatterCallbackFunction<Series | Point> = function (): string {
  return `${this.name}`;
};

const defaultLegend: LegendOptions = {
  symbolRadius: 0,
  borderWidth: 0,
  title: Object.freeze({ text: undefined }),
  floating: false,
  enabled: true,
  layout: 'horizontal',
  verticalAlign: 'bottom',
  align: 'center',
  useHTML: true,
  labelFormatter: legendFormatter,
};

const disabledLegend: LegendOptions = {
  enabled: false,
};

Object.freeze(defaultLegend);
Object.freeze(disabledLegend);

export function getLegend(enabled: boolean = true): LegendOptions {
  return enabled ? defaultLegend : disabledLegend
}
